import React from 'react';
import { Datagrid, TextField, BooleanField, EditButton } from 'react-admin';
import TList from '../../components/wrapper/TList';
import BusinessContractRouteListActions from './BusinessContractRouteListActions';
import BusinessContractRouteStatusButton from './BusinessContractRouteStatusButton';

const BusinessContractRouteList = props => (
	<TList {...props} actions={<BusinessContractRouteListActions businessContractId={props.filter.businessContractId} />}>
		<Datagrid>
			<TextField source="countryCode" sortable={false} />
			<TextField source="currencyCode" sortable={false} />
			<TextField source="mccFrom" sortable={false} />
			<TextField source="mccTo" sortable={false} />
			<TextField source="binGroupId" sortable={false} />
			<TextField source="userVerificationLevel" sortable={false} />
			<TextField source="paymentContext" sortable={false} />
			<TextField source="paymentInstrumentStatus" sortable={false} />
			<TextField source="comment" sortable={false} />
			<BooleanField source="allowed" sortable={false} />
			<BusinessContractRouteStatusButton />
			<EditButton basePath={'/businessContractRoutes'} />
		</Datagrid>
	</TList>
);

export default BusinessContractRouteList;
